module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_iterators.js
// module id = 127
// module chunks = 1